import { useEffect, useState } from "react";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ROLES = [
  { value: "admin", label: "管理员 (admin)" },
  { value: "user", label: "普通用户 (user)" },
  { value: "admin,user", label: "管理员 + 普通用户" },
];

export function DevRoleSwitcher() {
  const [role, setRole] = useState(() => localStorage.getItem("dev_role") || "admin");

  useEffect(() => {
    localStorage.setItem("dev_role", role);
    // Notify other components/tabs about the role change
    window.dispatchEvent(new StorageEvent("storage", { key: "dev_role", newValue: role }));
  }, [role]);

  return (
    <div className="flex items-center gap-2 text-xs">
      <span className="text-muted-foreground hidden lg:inline">当前角色</span>
      <Select value={role} onValueChange={setRole}>
        <SelectTrigger className="h-7 w-36 text-xs">
          <SelectValue placeholder="选择角色" />
        </SelectTrigger>
        <SelectContent>
          {ROLES.map((r) => (
            <SelectItem key={r.value} value={r.value} className="text-xs">
              {r.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
